import { type ReactNode, useRef, useState } from "react";
import "./CalendarEventsOpener.scss";
import { Level, type Size } from "@/shared/components/generic/UiEnums.ts";
import IconButton from "@/shared/components/generic/button/IconButton.tsx";

import PopMenu from "@/shared/components/generic/pop-menu/PopMenu.tsx";
import SiteCalendarEvents from "@/pages/human-resources/time-management/components/calendar-events/SiteCalendarEvents.tsx";
import BasicTooltipWithOffset from "@/pages/human-resources/time-management/components/BasicTooltipWithOffset.tsx";
import { useTranslation } from "react-i18next";
import type { CalendarDay } from "@/pages/human-resources/time-management/business/calendar/CalendarDay.ts";
import type { IconComponent } from "@/shared/components/generic/IconComponentType.ts";

interface Properties {
  buttonSize: Size;
  calendarDay: CalendarDay;
  timeChange: boolean;
  icon: IconComponent;
}

export default function CalendarEventsOpener(props: Properties): ReactNode {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement",
  });

  const anchorRef = useRef<HTMLDivElement>(null);
  const [popMenuOpen, setPopMenuOpen] = useState(false);

  function toggleMenu(): void {
    setPopMenuOpen((open) => !open);
  }

  function closeMenu(): void {
    setPopMenuOpen(false);
  }

  if (!props.calendarDay.isSpecial() && !props.timeChange) return undefined;
  return (
    <div className="calendar-events-opener" ref={anchorRef}>
      <BasicTooltipWithOffset title={t("analysis.events")}>
        <IconButton
          icon={props.icon}
          level={Level.TERTIARY}
          size={props.buttonSize}
          onClick={toggleMenu}
        />
      </BasicTooltipWithOffset>
      <PopMenu
        open={popMenuOpen}
        anchorEl={anchorRef.current}
        onClose={closeMenu}
        placement={"bottom"}
        borderRadius={4}
      >
        <SiteCalendarEvents
          calendarDay={props.calendarDay}
          timeChange={props.timeChange}
        />
      </PopMenu>
    </div>
  );
}
